import { TableDetail } from './TableDetail'
import { withTableDetail } from './withTableDetail'

const ConnectedTableDetail = withTableDetail(TableDetail)

export { ConnectedTableDetail as TableDetail }
